<template>
    <toolbar-option>
        <template slot="primary">
            <div>
                <input
                    :id="inputId"
                    type="text"
                    :value="coordinates"
                    @input="updateCoordinates"
                >
            </div>
        </template>
    </toolbar-option>
</template>

<script>
import uniqid from 'uniqid';
import baseOption from '@/options/mixins/base-option';

const CUSTOM_ATTR_NAME = 'google-map-data';

export default {
    name: 'google-map-coordinates',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Default Coordinates',
            isChecked: false,
            coordinates: '',
            inputId: uniqid(),
        };
    },

    watch: {
        coordinates() {
            const coordinatesArr = this.coordinates.split(',');

            this.value = { lat: parseFloat(coordinatesArr[0]), lng: parseFloat(coordinatesArr[1]) };
            this.onOptionChange(this.value);
            this.setChangedData(true);
            this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, { coordinates: this.value });
            if (this.value && this.isValidCoordinates(this.value)) {
                this.$root.$emit('flex::google-map::showOnMap', this.value);
            }
        },
    },

    methods: {
        updateCoordinates(e) {
            this.coordinates = e.target.value;
        },

        onSelectedElement() {
            this.value = this.selectedElements[0].coordinates;
            if (this.value) {
                this.coordinates = `${ this.value.lat },${ this.value.lng }`;
            }
        },

        isValidCoordinates(coord) {
            return coord && !Number.isNaN(coord.lat) && !Number.isNaN(coord.lng);
        },
    },
};
</script>

<style lang="scss" scoped>
.button {
    @extend %button-alt;
    @extend %button-compact;
}
</style>
